import { cookie } from 'ThreeTerminal_base/base';

// 投票认证登录操作
export const loginAuthFunc = () => {
    // 获取用户id
    const sid = cookie.get('sid');
    // 获取用户是否进行实名认证
    const IF_REAL = cookie.get('IF_REAL');

    if (!sid) {
        alert('请您先登录，再进行投票！');

        return false;
    } else if (IF_REAL && IF_REAL !== '0') {
        alert('此调查需要实名认证，请前往个人中心进行实名认证！');

        return false;
    }

    return true;
};
